import tokenStore from './tokenStore.js';
import VueRouter from 'vue-router';

import {
  PublicLayout,
  Login,
  ConfirmEmail,
  ForgotPassword,
  ResetPassword,
  ResetPasswordSuccess
} from '@/views/public/'

import {
  PrivateLayout,
  Dashboard,

  CoursesList,
  CoursesDetails,
  CoursesAddEdit,

  SubjectsList,
  SubjectsDetails,
  SubjectsAddEdit,

  VocabularyList,
  VocabularyDetails,
  VocabularyAddEdit,

  StudentsList,
  StudentsDetails,

  LectorsList,
  LectorsDetails,
  LectorsAddEdit,

  Reports,
  EmailSettings,
  Profile,

  Calendar,

  Messaging
} from '@/views/private/'

const publicPages = [
  {
    path: 'login',
    component: Login
  },
  {
    path: 'forgotpassword',
    component: ForgotPassword
  },
  {
    path: 'resetPassword',
    component: ResetPassword
  },
  {
    path: 'resetPasswordSuccess',
    component: ResetPasswordSuccess
  }, {
    path: 'confirmEmail',
    component: ConfirmEmail,
    props: (route) => ({
      email: route.query.email,
      token: route.query.token
    })
  }
];

let privatePages = [
  {
    path: '',
    component: Dashboard
  },
  {
    path: 'vocabulary',
    component: VocabularyList
  },
  {
    path: 'vocabulary/details/:id',
    component: VocabularyDetails,
    props: true
  },
  {
    path: 'vocabulary/add',
    component: VocabularyAddEdit
  },
  {
    path: 'vocabulary/edit/:id',
    component: VocabularyAddEdit,
    props: true
  },
  {
    path: 'subjects',
    component: SubjectsList
  },
  {
    path: 'subjects/details/:id',
    component: SubjectsDetails,
    props: true
  },
  {
    path: 'subjects/add',
    component: SubjectsAddEdit
  },
  {
    path: 'subjects/edit/:id',
    component: SubjectsAddEdit,
    props: true
  },
  {
    path: 'courses',
    component: CoursesList
  },
  {
    path: 'courses/details/:id',
    component: CoursesDetails,
    props: true
  },
  {
    path: 'courses/add',
    component: CoursesAddEdit
  },
  {
    path: 'courses/edit/:id',
    component: CoursesAddEdit,
    props: true
  },
  {
    path: 'students',
    component: StudentsList
  },
  {
    path: 'students/details/:id',
    component: StudentsDetails,
    props: true
  },
  {
    path: 'lectors',
    component: LectorsList
  },
  {
    path: 'lectors/add/',
    component: LectorsAddEdit,
  },
  {
    path: 'lectors/edit/:id',
    component: LectorsAddEdit,
    props: true
  },
  {
    path: 'lectors/details/:id',
    component: LectorsDetails,
    props: true
  },
  {
    path: 'reports',
    component: Reports
  },
  {
    path: 'emailSettings',
    component: EmailSettings
  },
  {
    path: 'profile',
    component: Profile
  },
  {
    path: 'calendar',
    component: Calendar
  },
  {
    path: 'messaging',
    component: Messaging
  },
];

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/public',
      component: PublicLayout,
      children: publicPages
    },
    {
      path: '/site',
      component: PrivateLayout,
      children: privatePages
    },
    { path: '*', redirect: '/site' }
  ]
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page

  const authRequired = !to.path.startsWith('/public/');
  const loggedIn = tokenStore.getToken();

  if (authRequired && !loggedIn) {
    return next({
      path: '/public/login',
      query: { returnUrl: to.path }
    });
  }

  next();
});

export default router;